export const MarqueeSection = ({ t }) => {
  const items = [...t.marquee, ...t.marquee];
  return (
    <section className="border-y border-black/10 bg-[#FFD600] py-5" data-testid="marquee">
      <div className="marquee-track flex whitespace-nowrap">
        {items.map((word, i) => (
          <span key={i} className="mx-6 flex items-center gap-6 font-display text-xl font-black uppercase tracking-tight text-black">
            {word}
            <span className="text-[#FF6B00]">✳</span>
          </span>
        ))}
      </div>
    </section>
  );
};
